// extracted by mini-css-extract-plugin
export default {"root":"Highlights-module-root","title":"Highlights-module-title","list":"Highlights-module-list","item":"Highlights-module-item"};